/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react'
import { Link } from 'react-router-dom'
class ForVendorSideNavBar extends React.Component {
  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className="">
              <Link to="/">
                <span className="pcoded-micon">
                  <i className="feather icon-home"></i>
                </span>
                <span className="pcoded-mtext">Dashboard</span>
              </Link>
            </li>
          </ul>
          <div className="pcoded-navigatio-lavel">Master</div>
          <ul className="pcoded-item pcoded-left-item">
            <li className=" pcoded-hasmenu">
              <a href="javascript:void(0)">
                <span className="pcoded-micon">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">Booking</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/booking-order">
                    <span className="pcoded-mtext">Bookings</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/current-booking">
                    <span className="pcoded-mtext">Current Bookings</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default ForVendorSideNavBar
